import React from 'react';
import {
    Box,
    Flex,
    Text,
    VStack,
    HStack,
    SimpleGrid,
    Icon,
    Tag
} from '@chakra-ui/react';
import { LuMessageCircle, LuMessageSquare, LuMail, LuBell, LuPhone } from 'react-icons/lu';
import { formatNumber } from '../../../utils/DefaultFunction';

const Channels = [
    {
        name: "WhatsApp",
        icon: LuMessageCircle,
        color: "#00a63e",
        description: "Rich messaging with media and buttons",
        id: 2,
    },
    {
        name: "SMS",
        icon: LuMessageSquare,
        color: "#155dfc",
        description: "Simple text messages",
        id: 1,
    },
    {
        name: "E-Mail",
        icon: LuMail,
        color: "#9810fa",
        description: "HTML emails with rich content",
        id: 3,
    },
    {
        name: "Push Notification",
        icon: LuBell,
        color: "#e60076",
        description: "Mobile app notifications",
        id: 6,
    },
    {
        name: "In-App Notification",
        icon: LuBell,
        color: "#4f39f6",
        description: "In-app messages and alerts",
        id: 5,
    },
    {
        name: "Voice (IVR)",
        icon: LuPhone,
        color: "#f54a00",
        description: "Automated voice calls",
        id: 4,
    },
];



const ChannelBox = ({ channelData, channelConfig }) => {
    return (
        <Box
            border="1px solid"
            borderColor="gray.200"
            borderRadius="lg"
            p={4}
            bg="white"
            _hover={{ boxShadow: 'sm' }}
            transition="all 0.2s"
        >
            <HStack spacing={2} mb={3}>
                <Icon as={channelConfig.icon} color={channelConfig.color} boxSize={5} />
                <Text fontWeight="semibold" fontSize="sm">
                    {channelConfig.name}
                </Text>
            </HStack>

            <VStack align="stretch" spacing={2}>
                <Flex justify="space-between">
                    <Text fontSize="sm" color="#64748b">Sent:</Text>
                    <Text fontSize="sm" fontWeight="medium">{formatNumber(channelData.sent)}</Text>
                </Flex>

                <Flex justify="space-between">
                    <Text fontSize="sm" color="#64748b">Delivered:</Text>
                    <Text fontSize="sm" fontWeight="medium">{formatNumber(channelData.delivered)}</Text>
                </Flex>

                <Flex justify="space-between">
                    <Text fontSize="sm" color="#64748b">Failed:</Text>
                    <Text fontSize="sm" fontWeight="medium" color="#fb2c36">{formatNumber(channelData.failed)}</Text>
                </Flex>

                {channelData.read > 0 && (
                    <Flex justify="space-between">
                        <Text fontSize="sm" color="#64748b">Read:</Text>
                        <Text fontSize="sm" fontWeight="medium">{formatNumber(channelData.read)}</Text>
                    </Flex>
                )}

                <Box pt={2} mt={2} borderTop="1px solid" borderColor="gray.100">
                    <Flex justify="space-between" mb={1}>
                        <Text fontSize="sm" color="#64748b">Delivery Rate:</Text>
                        <Text fontSize="sm" fontWeight="semibold" color="#00a63e">
                            {channelData.delivery_rate.toFixed(1)}%
                        </Text>
                    </Flex>

                    {channelData.read_rate > 0 && (
                        <Flex justify="space-between">
                            <Text fontSize="sm" color="#64748b">Read Rate:</Text>
                            <Text fontSize="sm" fontWeight="semibold" color="#155dfc">
                                {channelData.read_rate.toFixed(1)}%
                            </Text>
                        </Flex>
                    )}
                </Box>
            </VStack>
        </Box>
    );
};

const TemplateSection = ({ template }) => {
    const renderColor = (name) => {
        switch (name) {
            case "Transaction":
                return "#10b981"
            case "Marketing":
                return "#8b5cf6"
            case "Informational":
                return "var(--brand-primary)"
            case "Authentication":
                return "#f97316"

            default:
                return "#8b5cf6"
        }
    }
    return (
        <Box className='box-style-card'>
            <Flex justify="space-between" align="center" mb={4}>
                <VStack align="start" spacing={1}>
                    <Text fontSize="lg" fontWeight="semibold">
                        {template.template_name}
                    </Text>
                    <HStack fontSize="sm" color="#64748b" spacing={2}>
                        <Box w="15px" h="15px" borderRadius="full" bg={renderColor(template.type)} />
                        <Text>
                            {template.type} • {template.total_messages.toLocaleString()} total messages
                        </Text>
                    </HStack>

                </VStack>
                <Tag bg={"var(--brand-primary)"} fontSize="xs" px={3} py={1} color={"white"} borderRadius="md">
                    {template.delivery_rate}% Delivery
                </Tag>
            </Flex>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                {template.channels.sort((a, b) => b.sent - a.sent).map((channelData) => {
                    const channelConfig = Channels.find(c => c.id === channelData.channel_id);
                    if (!channelConfig) return null;

                    return (
                        <ChannelBox
                            key={channelData.channel_id}
                            channelData={channelData}
                            channelConfig={channelConfig}
                        />
                    );
                })}
            </SimpleGrid>
        </Box>
    );
};

export default function TemplateMessageBreakdown({ templateMessageBreakdown }) {

    return (
        <Box >
            <VStack align="stretch" spacing={6} >
                {templateMessageBreakdown.map((template) => (
                    <TemplateSection key={template.template_id} template={template} />
                ))}
            </VStack>
        </Box>
    );
}